import React, { useState, useEffect, useCallback } from "react";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect, useParams, useHistory } from "react-router-dom";
import Iframe from "react-iframe";
import "../css/Admin_css/admin-customize.css";
import Axios from "axios";
import myToast from "../Utils/MyToast";
import BackButton from "../ChildComponent/BackButton";

const DOCUMENT_TYPE = "pay_slip";
const DEFAULT_PRINTABLE_FILE = "PayRoll/pay_slip_sample1.php?";

const PayRollPayslip = () => {
  const token = localStorage.getItem("token");
  const [loggedIn] = useState(!!token);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(true);
  const [fileUrl, setFileUrl] = useState("");
  const [selectedSamplePosition, setSelectedSamplePosition] = useState(0);
  const [printableSamples, setPrintableSamples] = useState([]);

  const { salary_id, session_id } = useParams();

  const buildPayslipUrl = useCallback(
    (fileDirectory, fileName) => {
      const schoolCode = SessionManager.getSchoolCode();
      const base =
        fileDirectory && fileName
          ? `${process.env.REACT_APP_SERVER_NAME}${fileDirectory}${fileName}`
          : `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR_PRINTABLE}${DEFAULT_PRINTABLE_FILE}`;

      const joiner = base.includes("?") ? "&" : "?";
      return (
        `${base}${joiner}` +
        `salary_id=${encodeURIComponent(salary_id || "")}` +
        `&session_id=${encodeURIComponent(session_id || "")}` +
        `&school_code=${encodeURIComponent(schoolCode || "")}` +
        `&system_code=${encodeURIComponent(process.env.REACT_APP_SYSTEM_CODE || "")}`
      );
    },
    [salary_id, session_id]
  );

  const applySample = useCallback(
    (position, samples) => {
      const list = samples || [];
      const sample = list[position];
      if (sample?.file_directory && sample?.file_name) {
        setFileUrl(buildPayslipUrl(sample.file_directory, sample.file_name));
        setShowPreview(true);
        return;
      }
      setFileUrl(buildPayslipUrl());
      setShowPreview(true);
    },
    [buildPayslipUrl]
  );

  useEffect(() => {
    if (!salary_id || !session_id) {
      myToast.notify_warning("Missing payroll record identifiers.");
      return;
    }

    setLoading(true);
    const schoolCode = SessionManager.getSchoolCode();
    const functionName = "getPrintableSample.php?";
    const url = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${functionName}`;

    Axios.get(url, {
      params: {
        school_code: schoolCode,
        document_type: DOCUMENT_TYPE,
      },
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.api_status === "OK" && Array.isArray(response.data) && response.data.length > 0) {
          setPrintableSamples(response.data);
          setSelectedSamplePosition(0);
          applySample(0, response.data);
        } else {
          setPrintableSamples([]);
          applySample(0, []);
          if (response.api_remark) {
            myToast.notify_warning(response.api_remark);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching payslip samples:", error);
        setPrintableSamples([]);
        applySample(0, []);
      })
      .finally(() => setLoading(false));
  }, [salary_id, session_id, applySample]);

  const changeSample = (position) => {
    setSelectedSamplePosition(position);
    applySample(position, printableSamples);
  };

  if (!loggedIn) return <Redirect to="/Login" />;
  if (!salary_id || !session_id) {
    return (
      <div className="content">
        <div className="content-header" style={{ background: COLORS.primary_color_shade5 }}>
          <div className="rightside-content-header">
            <BackButton onClick={() => history.goBack()} />
          </div>
        </div>
        <div className="p-4">Invalid payslip link.</div>
      </div>
    );
  }
  if (loading) return <MyLoader />;

  return (
    <div className="content">
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <a href="#"> Salary Payslip </a>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton onClick={() => history.goBack()} />
        </div>
      </div>

      <div
        className="animated fadeInUp bg_page_white_rounded box_shadow"
        style={{ "--mMargin": "30px", padding: "0px" }}
      >
        <div
          style={{
            width: "100%",
            background: `linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade8} 100%)`,
            padding: "16px 24px",
            borderRadius: "8px 8px 0 0",
            boxShadow: `0 2px 4px ${COLORS.primary_color_shade3}`,
          }}
        >
          <h3
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#fff",
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <i className="fa fa-file-text-o" aria-hidden="true" style={{ color: "#fff" }} />
            Salary Payslip
          </h3>
        </div>

        {printableSamples.length > 0 && (
          <div style={{ padding: "14px 16px 6px" }}>
            <p
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "#64748b",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                marginBottom: 10,
              }}
            >
              Select Template
            </p>
            <div className="d-flex flex-wrap" style={{ gap: 16 }}>
              {printableSamples.map((item, index) => {
                const selected = selectedSamplePosition === index;
                return (
                  <div
                    key={item.sample_id || index}
                    onClick={() => changeSample(index)}
                    style={{
                      cursor: "pointer",
                      width: 160,
                      borderRadius: 12,
                      border: selected
                        ? `2px solid ${COLORS.primary_color_shade5}`
                        : "2px solid #e2e8f0",
                      background: selected ? COLORS.primary_color_shade0 : "#f8fafc",
                      boxShadow: selected
                        ? `0 2px 10px ${COLORS.primary_color_shade2}55`
                        : "0 1px 3px rgba(0,0,0,0.07)",
                      transition: "all 0.18s ease",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        padding: "18px 8px",
                        textAlign: "center",
                        fontSize: 13.5,
                        fontWeight: selected ? 700 : 500,
                        color: selected ? COLORS.primary_color_shade7 : "#475569",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.sample_name}
                    </div>
                    {selected && (
                      <div
                        style={{
                          height: 3,
                          background: COLORS.primary_color_shade5,
                          borderRadius: "0 0 8px 8px",
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        <div style={{ height: 1, background: "#e2e8f0", margin: "12px 16px" }} />

        <div style={{ padding: "0 16px 8px", display: "flex", alignItems: "center", gap: 8 }}>
          <i className="fa fa-eye" style={{ color: COLORS.primary_color_shade5, fontSize: 16 }} />
          <span style={{ fontWeight: 600, fontSize: 15, color: "#334155" }}>Preview</span>
        </div>

        <div
          style={{
            margin: "0 16px 20px",
            borderRadius: 10,
            overflow: "hidden",
            border: `1px solid ${COLORS.primary_color_shade2}`,
            position: "relative",
            minHeight: 320,
          }}
        >
          {showPreview && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                zIndex: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255,255,255,0.88)",
              }}
              aria-busy="true"
            >
              <MyLoader />
            </div>
          )}
          {fileUrl ? (
            <Iframe
              url={fileUrl}
              width="100%"
              height="1300px"
              id="iFramePayRollPayslip"
              frameBorder="0"
              display="initial"
              position="relative"
              onLoad={() => setShowPreview(false)}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PayRollPayslip;

